import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useTheme } from "../../util/themes";

import { BUTTON_STYLES } from "../../styles/buttonStyles";
import { TYPOGRAPHY_STYLES } from "../../styles/typographyStyles";
import {STYLES} from "../ShoppingCart/ShoppingCartStyles";

type Section = "info" | "direcciones" | "clientes" | "ordenes";

interface Props {
    section: Section;
    onSelect: (s: Section) => void;
    variant?: "sidebar" | "topbar";
}

export const ProfileSidebar: React.FC<Props> = ({ section, onSelect, variant = "sidebar" }) => {
    const theme = useTheme();
    
    const items: { id: Section; label: string }[] = [
        { id: "info", label: "Información" },
        { id: "direcciones", label: "Direcciones" },
        { id: "clientes", label: "Clientes" },
        { id: "ordenes", label: "Órdenes" },
    ];

    if (variant === "topbar") {
        return (
            <Box
                sx={{
                    border: `1px solid ${theme.colors.greyLight}`,
                    borderRadius: 2,
                    backgroundColor: theme.colors.background.paper,
                    overflowX: "auto",
                    overflowY: "hidden",
                    display: "flex",
                    alignItems: "center",
                    gap: 0,
                    WebkitOverflowScrolling: "touch",
                    "&::-webkit-scrollbar": { height: 0 },
                }}
            >
                {items.map((it) => {
                    const active = section === it.id;

                    return (
                        <Button
                            key={it.id}
                            onClick={() => onSelect(it.id)}
                            disableRipple
                            sx={{
                                ...BUTTON_STYLES.base,
                                textTransform: "none",
                                borderRadius: 0,
                                minWidth: "max-content",
                                px: 2,
                                py: 1.25,
                                height: 44,

                                ...TYPOGRAPHY_STYLES.rubikMedium,
                                fontWeight: active ? 800 : 600,

                                color: active ? theme.colors.text.primary : alpha(theme.colors.text.primary, 0.8),
                                backgroundColor: "transparent",

                                borderBottom: `2px solid ${active ? theme.colors.text.primary : "transparent"}`,

                                "&:hover": {
                                    backgroundColor: alpha(theme.colors.text.primary, 0.06),
                                },
                            }}
                        >
                            {it.label}
                        </Button>
                    );
                })}
            </Box>
        );
    }

    // === Sidebar (desktop)
    const Item = ({ id, label }: { id: Section; label: string }) => (
        <Button
            fullWidth
            onClick={() => onSelect(id)}
            sx={{
                justifyContent: "flex-start",
                textTransform: "none",
                px: 2,
                py: 1.5,
                color: section === id ? theme.colors.text.primary : theme.colors.text.secondary,
                fontFamily: "inherit",
                fontSize: "14px",
                fontWeight: section === id ? 600 : 400,
                backgroundColor: section === id ? theme.colors.greyLight : "transparent",
                "&:hover": { backgroundColor: theme.colors.greyLight },
            }}
        >
            {label}
        </Button>
    );

    return (
        <Box
            sx={{
                width: 240,
                border: `1px solid ${theme.colors.greyLight}`,
                borderRadius: "6px",
                py: 1,
                backgroundColor: theme.colors.background.paper,
            }}
        >
            <Typography
                sx={{
                    px: 2,
                    pb: 1,
                    fontSize: "15px",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    color: theme.colors.text.primary,
                }}
            >
                Configuración
            </Typography>

            <Item id="info" label="Información del perfil" />
            <Item id="direcciones" label="Direcciones" />
            <Item id="clientes" label="Clientes" />
            <Item id="ordenes" label="Órdenes" />
        </Box>
    );
};














